import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import(/* webpackChunkName: "usage" */ './index'),
  loading: () => null,
})
